const link = process.env.REACT_APP_SERVER_API_V2

const getDisableUser = () => `${link}/user/status/`

export default getDisableUser
